// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3eKmh","right":"Footer_right__3yaeU","buttons":"Footer_buttons__BVL2l"};